<!--任务分解 -->
<template>
  <div class="app-container">
    <div class="box-card">
      <div class="box-card-head">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
        >
          <!-- <template>
           <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
        </template> -->
        </dynamic-form>
        <div class="export-btn">
          <el-button
            icon="el-icon-upload2"
            @click="downloadExcel()"
          >导出</el-button>
        </div>
      </div>
      <drag-dialog
        append-to-body
        :show.sync="dialogVisible"
        title="新增任务"
        :enableDrag="true"
        width="600px"
        @close="cancel"
      >
        <dynamic-form
          :formConfig="contentConfig"
          v-model="content"
          labelWidth="120px"
          @submit="submit"
          @cancelForm="cancel"
          ref="pageForm"
        />
      </drag-dialog>
      <edit-data-table2
        :showNumber="false"
        :editable="true"
        :head="tableHead"
        :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
        :border="true"
        :data.sync="tableData"
        :toolBar="{ hidden: true }"
        height="500px"
        ref="delRew"
      >
        <template v-for="(value, key) in daysMap" v-slot:[key]="scope">
          <edit-data-table2
            :key="key"
            :showNumber="false"
            :editable="true"
            :showHeader="false"
            :head="innerTableHead"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
            :border="false"
            :data.sync="tableData[scope.$index][key]"
            :showAdd="getShow(value, tableData[scope.$index])"
            height=""
            :toolBar="{
              label: '操作',
              hidden: false,
              width: 80,
              minWidth: '',
              align: 'center',
              fixed: false,
            }"
            @addRow="
              addRow(
                key,
                scope.$index,
                tableData[scope.$index].taskReceiverPerson,
                value
              )
            "
          >
            <template #toolbar="{ row, $index }">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-edit"
                v-if="canEdit(row)"
                @click="editRow(row, scope.$index, key, value)"
              />
              <el-popover
                :ref="`popover-${row.id}`"
                placement="top"
                width="180"
                v-if="canEdit(row)"
              >
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="$refs[`popover-${row.id}`][0].doClose()"
                    >取消</el-button
                  >
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="subDelete(row.id, $index, scope.$index, key)"
                    >确定
                  </el-button>
                </div>
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-delete"
                  slot="reference"
                ></el-button>
              </el-popover>
            </template>
          </edit-data-table2>
        </template>
      </edit-data-table2>
    </div>
  </div>
</template>

<script>
import "./components/EditDataTable";
import DataTableMixin from '@/mixins/DataTableMixin'
import "@/components/dynamic-form"
import { parseTime } from "@/utils"
import DragDialog from "@/components/DragDialog"
import "@/components/dynamic-form"
import { findList, save, update, getDisposablePerson, delTask } from '@/api/bill/assignment'
import { downloadExcel } from "@/api/bill/ProjectPlan";
import moment from 'moment'// 导入文件

export default {
  name: "TaskDecompositionIndex",
  mixins: [DataTableMixin],
  components: { DragDialog },
  data () {
    return {
      daysMap: {},
      delLoading: false,
      content: {},
      contentConfig: {
        formItemList: [
          {
            label: '节点描述',
            key: 'projectNode',
            type: 'databox',
            span: 24,
            props: {
              label: 'taskNodeDescription',
              value: 'personId'
            },
            tableColumn: [
              { property: "milestonePlanName", label: "项目阶段", },
              { property: "milestonePlanRemark", label: "阶段描述", },
              { property: "name", label: "项目节点", },
              { property: "nodecode", label: "节点编号", query: { type: 'input' } },
              { property: "taskNodeDescription", label: "节点描述", query: { type: 'input' } },
              { property: "remark", label: "备注", query: { type: 'input' } },
            ],
            extendParms: {},
            disabled: true,
            multiple: false,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            span: 24,
            type: "input",
            key: "name",
            label: "任务名称",
            placeholder: "请输入任务名称",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          },
          {
            span: 24,
            type: "input",
            key: "taskContent",
            label: "任务内容",
            subtype: 'textarea',
            placeholder: "请输入任务内容",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          },
          {
            span: 24,
            label: '任务类型',
            key: 'taskType',
            type: 'select',
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }],
            optionsUrl: '/dict-detail',
            params: {
              code: 'task_package'
            }
          },
          {
            span: 24,
            label: '任务开始日期',
            key: 'plannedStartTime',
            type: 'date',
            placeholder: "请选择",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            events: {
              change: (value) => {
                if (value) {
                  if (value.getTime() > this.content.end || value.getTime() < this.content.begin) {
                   this.content.plannedStartTime = undefined
                   return this.$notify({ title: "任务开始日期不在当周时间范围内！", type: "error", duration: 2500 });
                  }
                  if (value.getTime() > this.content.plannedEndTime) {
                   this.content.plannedStartTime = undefined
                   return this.$notify({ title: "任务开始日期不能大于任务完成日期！", type: "error", duration: 2500 });
                  }
                }
              }
            }
          },
          {
            span: 24,
            label: '任务完成日期',
            key: 'plannedEndTime',
            type: 'date',
            placeholder: "请选择",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            events: {
              change: (value) => {
                if (value) {
                  if (value.getTime() < this.content.plannedStartTime) {
                   this.content.plannedEndTime = undefined
                   return this.$notify({ title: "任务完成日期不能小于任务开始日期！", type: "error", duration: 2500 });
                  }
                }
              }
            }
          },
          {
            span: 24,
            label: '可支配人天',
            key: 'disposableHumanNature',
            type: 'input',
            subtype: 'number',
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          },
        ],
        changeFlag: false,
      },
      changeContentList: [],
      dialogVisible: false,
      formConfig: {
        formItemList: [
          {
            type: "databox",
            key: "projectId",
            label: "项目号",
            placeholder: "请选择项目",
            value: "",
            span: 6,
            props: {
              label: "code",
              value: ""
            },
            url: "/bizTaskDecomposition/findProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "项目名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            span: 6,
            label: '选择月',
            key: 'time',
            type: 'date',
            subtype: 'month',
            valueFormat: 'yyyy-MM',
            clearable: false,
            disabled: true
          },
        ]
      },
      form: {},
      innerTableHead: [
        { label: '任务编号', prop: 'taskNodeCode'},
        { label: '任务内容', prop: 'taskContent'},
      ],
      tableHead: [
        {
          label: '可支配人员\\日期',
          prop: 'taskReceiverPerson.name',
          fixed: 'left',
          width: 200
        },
        {
          label: '第一周',
          prop: 'week1',
          align: 'center',
        },
      ],
      tableData: [],
      projectNumber: '',
    }
  },
  created () {
    this.initTime()
  },
  watch: {
    'form.projectId': {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          this.projectNumber = val.code
          this.getList(this.projectNumber, this.form.time)
        }
      },
      deep: true
    },
    'form.time': {
      handler (val, oldVal) {
        if (val !== oldVal) {
          if (this.projectNumber) {
            this.getList(this.projectNumber, this.form.time)
          }
        }
      }
    },
    'content.projectNode': {
      handler (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          const name = newVal.contentName ? newVal.contentName : newVal.name
          this.content.taskContent = name + '-'
        }
      },
      deep: true,
    },
  },
  methods: {
    // 导出
    downloadExcel () {
      const obj = Object.keys(this.form)
      const key = obj.find(i => i === 'projectId')
      const projectName = this.form[key].name
      const dates = new Date();
      const years = dates.getFullYear();
      let months = dates.getMonth() + 1;
      const days = dates.getDate();
      if (months < 9) {
        months = '0' + months
      }
      const date = years + months + days
      const title = projectName + "-" + "任务分解" + date
      const query = { projectCode: this.form[key] ? this.form[key].code : '', month: this.form.time }
      downloadExcel('/bizTaskDecomposition/exportV2', query, title)
    },
    // 初始化时间
    initTime () {
      if (!this.form.time) {
        this.form.time = parseTime(new Date(),"{y}-{m}")
      }
    },
    initDateDay() {
      var date = new Date();
      var w = date.getDay();
      var d = date.getDate();
      if (w === 0) {
          w = 7;
      }
      var config = {
        getMonth: date.getMonth() + 1,
        getYear: date.getFullYear(),
        getWeek: Math.ceil((d + 6 - w) / 7),
      }
      return config
    },
    getWeekNum() {
      // 获得当前日期是第几周的方法
      var year = new Date().getFullYear();
      var week = moment(new Date()).format("E");// 获得今天是星期几
      var startweek = moment(new Date(year + "-01-01")).format("E"); // 获得今年的1月1号是星期几
      // 今天到1月1号的时间戳之差
      var millisDiff =
        new Date(moment().format("yyyy-MM-DD")).getTime() -
        new Date(year + "-01-01").getTime();
      var days =
        (millisDiff -
          week * (24 * 60 * 60 * 1000) -
          (7 - startweek) * (24 * 60 * 60 * 1000)) /
        86400000;
      return days / 7 + 2;
      // 这里加的2代表的是本周和今年1月1号所在的那一周
    },
    getMonthWeek(a, b, c) {
            /**
        * a = d = 当前日期
        * b = 6 - w = 当前周的还有几天过完(不算今天)
        * a + b 的和在除以7 就是当天是当前月份的第几周
        */
        // var date = new Date(a, parseInt(b) - 1, c)
        var date = new Date()
        var w = date.getDay()
        var d = date.getDate()
        if (w === 0) {
            w = 7;
        }
        var config = {
            getMonth: date.getMonth() + 1,
            getYear: date.getFullYear(),
            getWeek: Math.ceil((d + 6 - w) / 7),
        }
        return config;
    },
    // 获取列表数据
    getList (projectCode, month) {
      this.tableData = [];
      getDisposablePerson({ projectCode, month}).then(res => { // 获取可支配人员
        if (res.code === 200) {
          // console.log(this.getWeekNum())
          // var getDate = this.initDateDay();
          // const week = parseInt(getDate.getWeek)
          // const week = parseInt(this.getWeekNum())
          var getDate = this.getMonthWeek()
          const week = getDate.getWeek
          debugger
          if (res.data.tableHead.length && this.tableHead instanceof Array) {
            // res.data.tableHead
            this.tableHead = []
            res.data.tableHead.forEach(item => {
              const prop = item.prop
              if (prop === 'taskReceiverPerson.name') {
                this.tableHead.push(item)
              } else {
                const index = parseInt(prop.substring(prop.length - 1, prop.length))
                if (index === week || index === (week + 1)) {
                  this.tableHead.push(item)
                }
              }
            })
            // 塞二级表格
            this.daysMap = this.tableHead.reduce((accumulator, cur,index) => {
              if (index !== 0) {
                accumulator[cur.prop] = cur
              }
              return accumulator
            }, {});
          }
          const resultTable = res.data.userList.map(item => {
            return {
              taskReceiverPerson: {
                name: item.personName,
                id: item.personId,
              },
              week1: [],
              week2: [],
              week3: [],
              week4: [],
              week5: [],
              week6: [],
              personnelDay: item.personnelDay
            }
          })
          findList({ projectCode, month }).then(res => { // 获取任务明细
            if (res.code === 200) {
              res.data.forEach(item => {
                resultTable.find((dataItem, index) => {
                  if (item.taskReceiver === dataItem.taskReceiverPerson.id) {
                    for (const key in this.daysMap) {
                      if (item.taskWeek === key) {
                        item.projectNode = item.bsProjectNode
                        item.projectNode.taskNodeDescription = item.taskNodeDescription
                        item.projectNode.taskState = item.taskState
                        delete item.bsProjectNode
                        resultTable[index][key].push(item)
                        break
                      }
                    }
                    return true
                  }
                })
              })
            }
            this.tableData = resultTable
          }).catch(() => {
            this.tableData = resultTable
            console.log(this.tableData);
          })
        }
      }).catch(() => {
        this.tableData = []
      })
    },
    // 修改删除按钮显示隐藏 N 未完成 Y 已完成 C 已转交
    canEdit (row) {
      if (row.taskState !== 'Y' && row.taskState !== 'C') {
        return true;
      } else {
        return false;
      }
    },
    // 新增按钮是否显示
    getShow (time, val) {
      // const personnelDays = val.personnelDay.map(item => { return item.occupyDate })
      // return personnelDays.includes(time)
      return true
    },
    // 增加行 新增任务弹窗
    addRow (key, index, taskReceiverPerson, time) {
      this.contentConfig.formItemList.find((item, theIndex) => {
        if (item.key === 'projectNode') {
          this.contentConfig.formItemList[theIndex].url = `/bizTaskDecomposition/findProjectNode/${this.projectNumber}/${time}`
          this.contentConfig.formItemList[theIndex].disabled = false
          this.contentConfig.changeFlag = !this.contentConfig.changeFlag
        }
      })
      this.content = {
        taskReceiver: taskReceiverPerson.id,
        // plannedStartTime: taskReceiverPerson.startTime,
        plannedStartTime: time.begin,
        endTime: taskReceiverPerson.endTime,
        end: time.end,
        begin: time.begin,
      }
      this.changeContentList = this.tableData[index][key]
      this.dialogVisible = true
    },
    // 修改行 新增任务弹窗修改
    editRow (row, index, key, time) {
      console.log("修改..", row)
      this.contentConfig.formItemList.find((item, theIndex) => {
        if (item.key === 'projectNode') {
          this.contentConfig.formItemList[theIndex].url = `/bizTaskDecomposition/findProjectNode/${this.projectNumber}/${time}`
          this.contentConfig.formItemList[theIndex].disabled = false
          this.contentConfig.changeFlag = !this.contentConfig.changeFlag
        }
      })
      row.projectNode.contentName = row.taskContent
      row.projectNode.nodecode = row.nodecode
      row.projectNode.planEntryId = row.modified ? row.projectNode.id : row.projectNode.planEntryId
      this.content = {
        ...row,
        end: time.end,
        begin: time.begin
      }
      this.changeContentList = this.tableData[index][key]
      this.dialogVisible = true
    },
    // 删除任务
    subDelete (id, index, tableIndex, key) {
      delTask(id).then(res => {
        if (res.code === 200) {
          this.tableData[tableIndex][key].splice(index, 1)
          this.$notify({ title: "删除成功！", type: "success", duration: 2500 });
        }
      })
    },
    // 新增任务提交
    submit () {
      this.content.projectCode = this.form.projectId.code
      this.content.taskState = "D"
      this.content.nodecode = this.content.projectNode.nodecode
      const plannedStartTime = new Date(this.content.plannedStartTime).getTime()
      const submitData = { ...this.content, projectNode: this.content.projectNode.planEntryId, plannedEndTime: new Date(this.content.plannedEndTime).getTime() }
      if (plannedStartTime > submitData.plannedEndTime + 24 * 60 * 60 * 1000 - 1) {
        return this.$notify({ title: "计划完成时间不能小于计划开始时间！", type: "error", duration: 2500 });
      }
      submitData.plannedStartTime = plannedStartTime
      delete submitData.startTime
      delete submitData.endTime
      if (this.content.id) {
        update(submitData).then(res => {
          if (res.code === 200) {
            this.changeContentList.find((item, index) => {
              if (item.id === this.content.id) {
                this.changeContentList.splice(index, 1, this.content)
                this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
                this.dialogVisible = false
                return true
              }
            })
            this.dialogVisible = false
          }
        })
      } else {
        save(submitData).then(res => {
          if (res.code === 200) {
            this.content.id = res.data.id
            this.content.taskNodeCode = res.data.taskNodeCode
            this.changeContentList.push(this.content)
            this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
            this.dialogVisible = false
          }
        })
      }
    },
    cancel () {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    .box-card-head {
      position: relative;
      /deep/ .el-form-item__label {
        width: 60px !important;
      }
      /deep/.el-form-item__content {
        margin-left: 60px !important;
      }
      /deep/ .el-col {
        padding-left: 0 !important;
      }
    }
    /deep/.el-table .cell.el-tooltip {
      white-space: pre-line;
    }
  }
  .export-btn {
    position: absolute;
    top: 8px;
    left: 53%;
  }
}
 /deep/ .el-table .cell{
    padding: 0;
  }
</style>
